import { DroppedScreenService } from './dropped-screen-service';
import { RootScopeEvents } from 'common/services/root-scope-types';
export class DroppedScreenServiceDoctor extends DroppedScreenService {
    constructor($injector) {
        super($injector);
        this.$injector = $injector;
        const communicationControl = $injector.get('communicationControl');
        const messages = {
            networkDisconnected: {
                icon: '#call-dropped',
                title: this.$translate.instant('video-chat.dropped.network.title'),
                description: this.$translate.instant('video-chat.doctor.dropped.network.description'),
                btnText: this.$translate.instant('video-chat.doctor.dropped.network.btn'),
            },
        };
        const handleNetworkDisconnected = (participants) => {
            this.message = {
                ...messages.networkDisconnected,
                onBtnClick: () => {
                    this.message = null;
                },
            };
            this.$rootScope.$evalAsync();
        };
        this.$rootScope.$on('activeProvider:stopBecauseOfNetworkError', (e, { participants }) => {
            handleNetworkDisconnected(participants);
        });
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SESSION_DISCONNECTED, (e, { reason, participants }) => {
            if (reason !== 'networkDisconnected')
                return;
            handleNetworkDisconnected(participants);
        });
    }
}
